<div class="product-filter" [class]="theme" [class.no-margin]="noMargin">
  <div class="product-sort">
    @if (showSortType) {
      <fieldset class="sort-option sort-by two-option">
        <legend class="sr-only">Sort by</legend>
        <label class="radio-label">
          <input type="radio" name="sortBy" [checked]="settings.sort_by == 'date'" (change)="sortBy('date')" aria-label="Sort by date" />
          <span [class.selected]="settings.sort_by == 'date'">Date</span>
        </label>
        <label class="radio-label">
          <input type="radio" name="sortBy" [checked]="settings.sort_by == 'abc'" (change)="sortBy('abc')" aria-label="Sort by {{ titleWord || 'Title' }}" />
          <span [class.selected]="settings.sort_by == 'abc'">{{ titleWord || "Title" }}</span>
        </label>
      </fieldset>
    }

    @if (showSortDirection) {
      <fieldset class="sort-option sort-direction two-option">
        <legend class="sr-only">Sort direction</legend>
        <label class="radio-label">
          <input type="radio" name="sortDirection" [checked]="settings.sort_direction == 'desc'" (change)="sortDirection('desc')" aria-label="Sort descending" />
          <span [class.selected]="settings.sort_direction == 'desc'"><fa-icon icon="arrow-down"></fa-icon></span>
        </label>
        <label class="radio-label">
          <input type="radio" name="sortDirection" [checked]="settings.sort_direction == 'asc'" (change)="sortDirection('asc')" aria-label="Sort ascending" />
          <span [class.selected]="settings.sort_direction == 'asc'"><fa-icon icon="arrow-up"></fa-icon></span>
        </label>
      </fieldset>
    }

    @if (showListGrid) {
      <fieldset class="sort-option sort-display two-option">
        <legend class="sr-only">Display view</legend>
        <label class="radio-label">
          <input type="radio" name="displayView" [checked]="appService.prefersGrid" (change)="appService.prefersGrid = true" aria-label="Grid view" />
          <span [class.selected]="appService.prefersGrid"><fa-icon icon="th"></fa-icon></span>
        </label>
        <label class="radio-label">
          <input type="radio" name="displayView" [checked]="!appService.prefersGrid" (change)="appService.prefersGrid = false" aria-label="List view" />
          <span [class.selected]="!appService.prefersGrid"><fa-icon icon="list-ul"></fa-icon></span>
        </label>
      </fieldset>
    }
  </div>
  @if (showQueryInput) {
    <div class="filter-input">
      <label for="filterSearch" class="sr-only">Search...</label>
      <div class="search" aria-hidden="true"><fa-icon icon="search"></fa-icon></div>
      <input id="filterSearch" type="text" (keyup)="filterList($event)" [(ngModel)]="filterQuery" aria-label="Search..." placeholder="Search..." />
      @if (filterQuery) {
        <button type="button" class="clear" (click)="clear()" aria-label="Clear search">
          <fa-icon icon="times"></fa-icon>
        </button>
      }
    </div>
  }
</div>
